import classNames from 'classnames';
import React from 'react';

import { AsComponent } from '../As';

import { InputProps } from './Input';

export const Checkbox = React.forwardRef(function Checkbox<T extends AsComponent>(
  { invalid, className, children, ...props }: React.PropsWithChildren<InputProps<T>>,
  ref: React.Ref<any>
) {
  return (
    <div className={classNames('flex', className)}>
      <input
        {...props}
        {...{ ref }}
        className={classNames(
          'form-checkbox text-brand mt-[2px] h-5 w-5 cursor-pointer rounded focus:ring-[#2E4C86]',
          invalid ? 'border-red-500 bg-red-100' : 'border-border/50'
        )}
      />

      <label className="ml-2 cursor-pointer select-none" htmlFor={props.id}>
        {children}
      </label>
    </div>
  );
});
